import React, { useContext } from 'react'
import config from '../../config'
import { useAuth } from '../../auth/AuthContext'
import GrantContent from '../../components/GrantContent'
import { useHistory } from '../../router/history'
import AppContext from '../../state/AppContext'
import * as Permisos from '../../utils/Permisos'
import { HelpIcon, MenuIcon } from './icons'
import KarteraAccountMenu from './KarteraAccountMenu'
import KarteraLogo from './KarteraLogo'
import KarteraTasks from './KarteraTasks'
import KarteraThemeSwitch from './KarteraThemeSwitch'

const iconButtonClass = 'flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-xl border-0 text-k-ink-2'

const KarteraHeader = ({ showNavToggle = true }) => {
    const history = useHistory()
    const { user, logout } = useAuth()
    const { appContext, setAppContext } = useContext(AppContext)

    const toggleNavbar = () => setAppContext({ ...appContext, navbar: { open: !appContext.navbar.open } })

    return (
        <header className="relative z-20 flex min-h-[68px] shrink-0 flex-nowrap items-center gap-2 border-b border-k-line bg-k-surface px-3 py-2.5 md:gap-x-5 md:px-[clamp(16px,2.5vw,28px)]">
            {showNavToggle && (
                <button type="button" aria-label="Abrir menú" onClick={toggleNavbar} className={`${iconButtonClass} relative z-10 -ml-1 bg-transparent hover:bg-k-hover lg:hidden`}>
                    <MenuIcon />
                </button>
            )}

            <KarteraLogo className="absolute left-1/2 top-1/2 z-[1] -translate-x-1/2 -translate-y-1/2 md:static md:z-auto md:translate-x-0 md:translate-y-0 lg:w-48" />

            {user && (
                <div className="relative z-10 ml-auto flex shrink-0 items-center gap-1.5">
                    <KarteraThemeSwitch className="mr-1 hidden md:flex" />
                    <a
                        href={config.contacts.whatsappUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Ayuda"
                        title="Ayuda"
                        className={`${iconButtonClass} hidden hover:bg-k-hover hover:text-k-ink md:flex`}
                    >
                        <HelpIcon />
                    </a>
                    <GrantContent permisos={[Permisos.TAREAS_R]}>
                        <KarteraTasks />
                    </GrantContent>
                    <span aria-hidden="true" className="mx-1.5 hidden h-7 w-px bg-k-line md:block" />
                    <KarteraAccountMenu user={user} onNavigate={(to) => history.push(to)} onLogout={logout} />
                </div>
            )}
        </header>
    )
}

export default KarteraHeader
